var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_589_1935",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_589_1935",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAZKADAAQAAAABAAAAZAAAAAAvu95BAAADzklEQVR4Ae2dvU8UQRiHZ949NfGjoMLEFjliSIydf4S2NhilUQsjltrZYql2xERioLraP8JCwcQNH6E1akGifBglcOOMd2c2d8vtvMPOe3u5Hw17O79539nnYQ72IIdS+AABEAABEAABEAABEAABEAABWQK6025i4tGZWm33vn08Y4ya1lqd64zhc/kELON9y/izUnopSfYW0rRx4Lr8EzI5eecSkXqnFF0tvzUqFhGwclaNad7Y3Hz7Rbd2xs/3kFGELfa4XrE75Tolyc4DyIgN26e+udZsnr1HRHrGJ45MfAJHR/o2NZvmSvxW6OBDQGszTVrr8z5hZOITcC4ofht04BCAEA4tgSyECEDmtIAQDi2BLIQIQOa0gBAOLYEshAhA5rSAEA4tgSyECEDmtIAQDi2BLIQIQOa0gBAOLYEshAhA5rSAEA4tgSyECEDmtIAQDi2BLIQIQOa0gBAOLYEshAhA5rSAEA4tgSyECEDmtIAQDi2BLIQIQOa0gBAOLYEshAhA5rSAEA4tgSyECEDmtIAQDi2BLIQIQOa0gBAOLYEshAhA5rSAEA4tgSyECEDmtIAQDi2BLIQIQOa0qHHC2ez6+uL/d4HInsdxi8DU1KwJYYEdEkIt4hwIiQg3pDSEhFCLOAdCIsINKQ0hIdQizoGQiHBDSkNICLWIc4LvQ4rWVK/fvWXfH+2Ffde0i9msfbOub/bx3MbGYiN7vvt42Od3X4/v44g7pFeGW1Rb0MviBQ77/OIrzEtEE9K9M7LN+411cv0y/caqMr+zDu7naEK4C0G+RQBCKvaVACGjIqT901Tu5dqxr7kDmZPDPj9zKazDmDtkLg9qW8Zjj1UO+3yPS+yN6NDX7fH7kF6Y2TOhXGPukOz6cOxJAEI8QUnFIESKtGcfCPEEJRWDECnSnn0gxBOUVAxCpEh79gm+D/GsX9mYvUF9bn8n87RogaH3E0V1jxsf2R1iX8J/Uq/Pzh8HZlDnR1aIA15FKSMtpIpSRl5I1aRAiDNiP6ry9AUhLR+VkQIhGSHucNA7BUK6hAxaSrQ/lMu5zqE65XaKvSn8Lb1o7JD+xJ/1Hy5/FELKZ3qiimSM2TtRBUwuk8CO+8eSaZkVUSucgDE6dU9Zy+ElMLNMAkRmiQ4PLyzYl6JXyyyMWnwC9lvHR6L917S19eqP++fq9pZohV8GM8og4GQoldxM08ZB4gpub3/aHR+//EapU9+NoTGlzJj93nK6jGaokU+g9cMUfSBS80ny6+Ha2vKP/CTOggAIgAAIgAAIgAAIgAAIgEBcAn8BKevcLErX2zoAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatOff);
export default __webpack_public_path__ + "static/media/chat_off.db85cca3f9101e1888ed4fb822ac8373.svg";
export { ForwardRef as ReactComponent };